import { ProviderContactDatabase } from "../../../../types";
import useDeleteProviderContact from "../../api/useDeleteProviderContact";
import ConfirmDeleteDialog from "../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog";

type Props = {
  contact: ProviderContactDatabase;
  onClose: () => void;
}

export default function DeleteContactModal(props: Props) {
  const { mutateAsync } = useDeleteProviderContact();

  return (
    <ConfirmDeleteDialog
      title="Supprimer le contact"
      onConfirm={() => mutateAsync({ providerId: props.contact.provider_id, contactId: props.contact.id })}
      onClose={props.onClose}
    >
      Êtes-vous sûr de vouloir supprimer le contact « {props.contact.name} » ?
    </ConfirmDeleteDialog>
  );
}
